"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VirtualTryOnDialog = void 0;
var _presentationProductDetail = require("@ori/presentation-product-detail");
var _react = require("react");
var _utils = require("../../utils");
var _api = require("../api");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const VirtualTryOnDialog = ({
  open,
  onClose
}) => {
  const [currentShade, setCurrentShade] = (0, _react.useState)();
  const {
    defaultCurrentShade,
    shades
  } = (0, _api.useShades)();
  const setCurrentShadeProductCode = (0, _react.useCallback)(productCode => {
    const shade = shades.find(s => s.productCode === productCode);
    if (shade) {
      setCurrentShade(shade);
      (0, _utils.setTryOnProduct)(shade.productCode);
    }
  }, [shades]);
  (0, _react.useEffect)(() => {
    if (defaultCurrentShade) {
      setCurrentShade(defaultCurrentShade);
      (0, _utils.setTryOnProduct)(defaultCurrentShade.productCode);
    }
  }, [defaultCurrentShade]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Dialog, {
    hideCloseButton: true,
    keepMounted: true,
    open: open,
    onClose: onClose,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
      id: _constants.VIRTUAL_TRY_ON_PDP_CONTAINER,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Toolbar, {
        children: currentShade ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CarouselWrapper, {
          numberOfSlides: shades.length,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationProductDetail.ShadesCarousel, {
            currentShade: currentShade,
            shades: shades,
            shouldReplaceUrl: false,
            setCurrentShadeProductCode: setCurrentShadeProductCode
          })
        }) : null
      })
    })
  });
};
exports.VirtualTryOnDialog = VirtualTryOnDialog;